/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-12 17:35:34
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-13 17:07:29
 * @Content:
 */

import React, { FC, memo } from "react";
import GamblingEndModal from "..";
import Modal from "../../../../components/Common/Modal/Modal";
import "./index.less";

const PREFIX = "GamblingEndFailModal";

type IProps = {
  visible: boolean;
  onClose: () => void;
};

const GamblingFailModal: FC<IProps> = memo(({ visible, onClose }) => {
  return (
    <GamblingEndModal
      visible={visible}
      onClose={onClose}
      className={PREFIX}
      footerBtnText={"好的"}
      onFooterBtnClick={onClose}
    >
      很遗憾！你未完成挑战, 不要灰心,咱们约好了,下次一定挑战成功!
    </GamblingEndModal>
  );
});

export default GamblingFailModal;
